import { Button } from "antd";
import Container from "components/container";
import NavMobile from "components/navMobile";
import * as appRoutes from "config/routes.config";
import { FC } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/app/header/logo.svg";
import st from "../../screens/app/common.module.css";
import s from "./assets/headers.module.css";

interface Props { }

const WhenNotConnected: FC = () => {
  //!HOOKS

  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const shouldHideHeader = [
    "repair",
  ].some((part) => path.includes(part));

  return (
    <header className={s.app__header}>
      <Container>
        <div className={s.nav}>
          <div className={st.logoContainer}>
            <Link to={"/"}>
              <img src={logo} height={50} alt="logo" ></img>
            </Link>
          </div>

          {!shouldHideHeader && <NavMobile />}

          {!shouldHideHeader && <ul className={s.nav__links}>
            <li className={s.nav__item}>
              <Link to="/">Accueil</Link>
            </li>
            <li className={s.nav__item}>
              <Link to={appRoutes.PROFESSEUR}>
                Professeur
              </Link>
            </li>
            <li className={s.nav__item}>
              <Link to={appRoutes.PARENT}>
                Parent
              </Link>
            </li>
            <li className={s.nav__item}>
              <Link to={appRoutes.ORGANISME}>
                Organisme
              </Link>
            </li>
            <li className={s.nav__item}>
              <Link to={appRoutes.STUDENT_SEARCH_BEST_TEACHER}>
                Trouver un enseignant
              </Link>
            </li>
            <li className={s.nav__item}>
              <Link to={appRoutes.STUDENT_MY_CONTENT}>Nos ressources</Link>
            </li>
            <li className={s.nav__item_button}>
              <Link to={appRoutes.LOGINS}>
                <Button className={st.newLoginButton}>
                  Se connecter
                </Button>
              </Link>
            </li>
          </ul>}
        </div>
      </Container>
    </header>
  );
};

export default WhenNotConnected;
